function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h32v32h-32z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#222",
  fillRule: "nonzero",
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21.789.00075-15.789-.00075c-.65775 0-1.05225.3955-1.05225 1.05325v.80025l13.6835.00025c.6585 0 1.0525.39425 1.0525 1.05275v18.6725h2.1055c.6585 0 1.053-.39425 1.053-1.05325v-19.4725c-.00025-.65775-.39475-1.0525-1.05325-1.0525z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.0525 3.4215-15.7895-.0005c-.65775 0-1.05225.39475-1.05225 1.053v19.473c0 .658.3945 1.053 1.05225 1.053h15.7895c.65825 0 1.05275-.395 1.05275-1.053v-19.473c0-.658-.3945-1.0525-1.05275-1.0525zm-3.158 16.3415h-9.47325v-1.579h9.4735v1.579zm0-4.737h-9.47325v-1.5785h9.4735v1.5785zm0-4.7365h-9.47325v-1.579h9.4735v1.579z"
})));

var SvgAllPostsBlack = function SvgAllPostsBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAllPostsBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AllPostsBlack.62176a60.svg";
export { ForwardRef as ReactComponent };